import { Box, Button, IconEdit, Skeleton } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { useListingActions } from '../../../context/listing-actions'
import { ListingAddress } from '../../../components/listing-address'
import { ListingInfo } from '../../../components/listing-info'
import { ListingStateButton } from '../../../components/listing-state-button'
import { useListingData } from '../../../context/listing-data'

export const HeaderSection = () => {
  const { t } = useTranslation()

  const { editListing } = useListingActions()
  const { loading } = useListingData()

  if (loading) return <Skeleton.Text lineCount={2} />

  return (
    <Box
      width="full"
      paddingTop="small"
      paddingBottom="medium"
      display="flex"
      flexDirection="row"
      justifyContent="spaceBetween"
      gap="gutter"
    >
      <Box display="flex" flexDirection="column" gap="medium">
        <ListingAddress />
        <ListingInfo />
      </Box>

      <Box display="flex" flexDirection="row" gap="small" style={{ height: '44px' }}>
        <Button variant="ghost" icon={<IconEdit />} onClick={editListing}>
          {t('Edit')}
        </Button>

        <ListingStateButton />
      </Box>
    </Box>
  )
}
